var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { FieldOptions, FieldRadio } from "../../";

var RadioWidget = (_temp2 = _class = function (_Component) {
    _inherits(RadioWidget, _Component);

    function RadioWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, RadioWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(_this.props.id, event.target.value);
            }
        }, _this.onBlur = function (event) {
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.props.id, event.target.value);
            }
        }, _this.onChange = function (value, event) {
            _this.props.onChange(value);
        }, _this.getOptions = function () {
            var _this$props$options = _this.props.options,
                enumOptions = _this$props$options.enumOptions,
                enumDisabled = _this$props$options.enumDisabled;


            var options = [];

            enumOptions.map(function (_ref, i) {
                var value = _ref.value,
                    label = _ref.label;

                var disabled = enumDisabled && enumDisabled.indexOf(value) != -1;
                var checked = _this.props.value === value;

                options.push({
                    value: value,
                    checked: checked,
                    disabled: disabled,
                    label: label
                });
            });

            return options;
        }, _this.renderOptions = function () {
            var _this$props = _this.props,
                id = _this$props.id,
                schema = _this$props.schema,
                value = _this$props.value,
                required = _this$props.required,
                disabled = _this$props.disabled,
                readonly = _this$props.readonly,
                multiple = _this$props.multiple,
                autofocus = _this$props.autofocus;


            var name = id + "_radio";

            var options = _this.getOptions();

            return options.map(function (option, index) {

                return React.createElement(FieldRadio, _extends({}, option, { name: name,
                    onChange: _this.onChange,
                    onBlur: _this.onBlur,
                    onFocus: _this.onFocus
                }));
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    RadioWidget.prototype.render = function render() {
        var inline = this.props.options.inline;


        return React.createElement(
            FieldOptions,
            { inline: inline },
            this.renderOptions()
        );
    };

    return RadioWidget;
}(Component), _class.defaultProps = {
    autofocus: false
}, _temp2);
RadioWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
        enumOptions: PropTypes.array,
        inline: PropTypes.bool
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func
} : {};


export default RadioWidget;